import { render } from "./TextareaArray.vue?vue&type=template&id=7eaf56d4"
import script from "./TextareaArray.vue?vue&type=script&lang=js"
export * from "./TextareaArray.vue?vue&type=script&lang=js"
script.render = render

export default script